<template>
  <el-row>
    <el-card shadow="never" class="mt-0 card-promo">
      <el-radio-group
        v-model="Promo.promoTargetPushCart.promoValue.promoValueType"
        style="width: 100%"
      >
        <template v-for="(formradio, idx) in formRadio">
          <el-row :key="idx">
            <el-col :span="8">
              <el-radio :label="formradio.value" class="mt-2">{{
                formradio.label
              }}</el-radio>
            </el-col>
            <el-col :span="16">
              <el-form-item size="small" style="margin: 0">
                <el-row
                  type="flex"
                  justify="space-between"
                  style="flex-wrap: wrap"
                >
                  <template v-for="(form, idx) in formradio.form">
                    <el-col
                      :span="form.span"
                      style="margin-bottom: 18px"
                      :key="idx"
                    >
                      <el-input
                        v-if="
                          form.type == 'text' ||
                          form.type == 'password' ||
                          form.type == 'number'
                        "
                        v-model="
                          Promo.promoTargetPushCart.promoValue[formradio.value][
                            form.id
                          ]
                        "
                        :placeholder="form.placeholder"
                        :type="form.type"
                        @focus="e => onFocusText(e, formradio.value, form.id)"
                        @blur="e => onBlurNumber(e, formradio.value, form.id)"
                        :disabled="disabledField(formradio.value)"
                      ></el-input>
                      <el-select
                        v-else-if="form.type == 'select'"
                        v-model="
                          Promo.promoTargetPushCart.promoValue[formradio.value][
                            form.id
                          ]
                        "
                        multiple
                        :placeholder="form.placeholder"
                        :disabled="disabledField(formradio.value)"
                      >
                        <el-option
                          v-for="item in form.data"
                          :key="item.value"
                          :label="item.name"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </el-col>
                  </template>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
      </el-radio-group>
    </el-card>
  </el-row>
</template>

<script>
import { thousandSeprator, unThousandSeprator } from "@/helpers";

export default {
  props: ["Promo"],
  data() {
    return {
      activeName: "first"
    };
  },
  computed: {
    formRadio() {
      return [
        {
          label: "Discount",
          value: "discount",
          form: [
            {
              type: "text",
              id: "value",
              label: "",
              placeholder: "Discount Value",
              rules: []
            },
            {
              type: "text",
              id: "max",
              label: "",
              placeholder: "Max Value",
              rules: []
            }
          ]
        }
      ];
    }
  },
  methods: {
    disabledField(value) {
      return this.Promo.promoTargetPushCart.promoValue.promoValueType !== value
    },
    onBlurNumber(e, field, subField) {
      this.Promo.promoTargetPushCart.promoValue[field][subField] = thousandSeprator(e.target.value)
    },
    onFocusText(e, field, subField) {
      this.Promo.promoTargetPushCart.promoValue[field][subField] = unThousandSeprator(e.target.value)
    }
  }
};
</script>

<style>
.tab-promo /deep/ .el-tabs__item {
  padding: 0px 20px !important;
}
.tab-promo /deep/ .el-tabs__item.is-active {
  color: white !important;
  background-color: #2356c9;
  padding: 0px 20px !important;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  font-weight: bold;
}
.tab-promo /deep/ .el-tabs__header.is-top {
  margin: 0 !important;
}
.card-promo {
  background-color: #f6f6f6 !important;
}
</style>
